import React from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import { options } from "util/reactTableFuncs";
import { Account } from "types";
import { Table } from "@avlino-inc/alenza-react";
import styles from "components/dashboard/Dashboard.module.scss";

const AccountsTable = ({
  accounts,
  rowEvents,
  showSearch,
  showDescription,
  cardTable
}: {
  accounts: Account[];
  rowEvents: any;
  showSearch: boolean;
  showDescription?: boolean;
  cardTable?: boolean;
}) => {
  const { SearchBar } = Search;
  const columns: Array<Object> = [
    {
      dataField: "name",
      text: "Account",
      sort: true,
      headerAlign: "left",
      align: "left"
    }
  ];
  if (showDescription) {
    columns.push({
      dataField: "description",
      text: "Description",
      headerAlign: "left",
      align: "left"
    });
  }
  let dataSorted =
    accounts &&
    accounts.sort((a: Account, b: Account) => a.name.localeCompare(b.name));
  if (dataSorted && showDescription) {
    // Limit the description to a certain number of characters
    dataSorted = dataSorted.map((account: Account) =>
      account.description && account.description.length > 30
        ? {
            ...account,
            description: `${account.description.substring(0, 30)}...`
          }
        : account
    );
  }

  return (
    <div>
      {accounts ? (
        <ToolkitProvider
          keyField="id"
          data={dataSorted}
          columns={columns}
          search
        >
          {(props: any) => (
            <>
              { showSearch ?
              <div className={styles["table__search-container"]}>
                <SearchBar
                  className={styles["table__search-container__search-bar"]}
                  {...props.searchProps}
                />
              </div>
              : null }
              <div className={Table.classNames.table}>
                {cardTable ? (
                  <BootstrapTable
                    {...props.baseProps}
                    classes={styles["table"]}
                    bordered={false}
                    bootstrap4
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    classes={styles["table"]}
                    bordered={false}
                    bootstrap4
                    hover
                    condensed
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                )}
              </div>
            </>
          )}
        </ToolkitProvider>
      ) : (
        <p>No Accounts Available</p>
      )}
    </div>
  );
};

export default AccountsTable;
